import _ from 'lodash'

export function extractErrorToString (e, fallbackMessage) {
  if (!e) {
    return fallbackMessage
  }

  if (!e.body) {
    return fallbackMessage
  }

  if (_.isString(e.body)) {
    return e.body
  }

  if (_.isObject(e.body)) {
    let keys = _.keys(e.body)
    let values = _.values(e.body)
    let errorString = ""
    for (let i = 0; i < values.length; i++){
      if (keys.length >= i){
        errorString += `${keys[i]} - ${values[i]}; ` 
        continue
      }

      errorString += `${values[i]};`
    }
    return errorString
  }

  if (_.isArray(e.body)) {
    return _.join(e.body, ', ')
  }
}

export function extractErrorToArray (e, fallbackMessage) {
  if (!e) {
    return [fallbackMessage]
  }

  if (!e.body) {
    return [fallbackMessage]
  }

  if (_.isString(e.body)) {
    return [e.body]
  }

  if (_.isObject(e.body)) {
    return _.values(e.body)
  }

  if (_.isArray(e.body)) {
    return e.body
  }
}



// WEBPACK FOOTER //
// ./src/helpers/api.js